import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SITE_URL = 'https://invfly.com';

function upsertMeta(attrName, attrValue, content) {
  let el = document.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/** Keeps meta descriptions within a typical search snippet length. */
export function trimMetaDescription(text, max = 158) {
  const t = text.replace(/\s+/g, ' ').trim();
  if (t.length <= max) return t;
  const cut = t.slice(0, max - 1);
  const i = cut.lastIndexOf(' ');
  return (i > 60 ? cut.slice(0, i) : cut) + '…';
}

/**
 * Updates document title, description, canonical, Open Graph, and Twitter tags.
 * Use on each public route; set noIndex for auth and admin screens.
 */
export default function Seo({ title, description, noIndex = false }) {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const hasBrand = /invfly/i.test(title);
    const fullTitle = hasBrand ? title : `${title} | InvFly`;
    document.title = fullTitle;

    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', 'InvFly');
    upsertMeta('property', 'og:url', `${SITE_URL}${pathname === '/' ? '' : pathname}`);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', fullTitle);
    upsertMeta('name', 'twitter:description', description);

    upsertMeta('name', 'robots', noIndex ? 'noindex, nofollow' : 'index, follow');

    upsertLink('canonical', `${SITE_URL}${pathname === '/' ? '' : pathname}`);
  }, [title, description, noIndex, pathname]);

  return null;
}
